'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497 from "./presto.-Presto-Router$$anon$97.js";
import * as $j_presto$002e$002dSign$002dDocument$002dPage$0024 from "./presto.-Sign-Document-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$96() {
  this.bqQ = null;
  this.bqI = null;
  this.bqJ = false;
  this.bqR = null;
  this.bqS = false;
  this.bqV = null;
  this.bqO = null;
  this.bqP = false;
  this.bqK = null;
  this.bqL = false;
  this.bqM = null;
  this.bqN = false;
  this.bqT = false;
  this.bqU = false;
  this.bqQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bqV = "SignDocumentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$96 as $c_Lpresto_PrestoRouter$$anon$96 };
$p = $c_Lpresto_PrestoRouter$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$96;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$96() {
}
export { $h_Lpresto_PrestoRouter$$anon$96 as $h_Lpresto_PrestoRouter$$anon$96 };
$h_Lpresto_PrestoRouter$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bqQ;
});
$p.M = (function() {
  if ((!this.bqJ)) {
    this.bqI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bqJ = true;
  }
  return this.bqI;
});
$p.O = (function() {
  if ((!this.bqS)) {
    this.bqR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bqS = true;
  }
  return this.bqR;
});
$p.D = (function() {
  return this.bqV;
});
$p.t = (function() {
  if ((!this.bqP)) {
    this.bqO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqP = true;
  }
  return this.bqO;
});
$p.N = (function() {
  if ((!this.bqL)) {
    this.bqK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqL = true;
  }
  return this.bqK;
});
$p.Q = (function() {
  if ((!this.bqN)) {
    this.bqM = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497.$c_Lpresto_PrestoRouter$$anon$97();
    this.bqN = true;
  }
  return this.bqM;
});
$p.v = (function() {
  if ((!this.bqU)) {
    this.bqT = false;
    this.bqU = true;
  }
  return this.bqT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee597) => ((p) => \u03b4scrutinee597))($j_presto$002e$002dSign$002dDocument$002dPage$0024.$m_Lpresto_SignDocumentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$96, "presto.PrestoRouter$$anon$96", ({
  Pe: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$96 as $d_Lpresto_PrestoRouter$$anon$96 };
//# sourceMappingURL=presto.-Presto-Router$$anon$96.js.map
